import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IEmailTemplate } from '@/shared/model/email-template.model';

const baseApiUrl = 'api/default-email-templates';
const baseApiUrlTemplate = 'api/v1/templates';
const baseApiUrlAppTemplate = 'api/v1/app';

export default class EmailTemplateService {
  public find(id: number): Promise<IEmailTemplate> {
    return new Promise<IEmailTemplate>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  public preview(entity?: any, subject?: any, headerFooter?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrlTemplate}/preview`, { bodyTemplate: entity, ...subject, ...headerFooter })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  public retrieveDefaultTemplateByIdentifier(identifier?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrlAppTemplate}/templates?identifier=${identifier}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  public retrieveHeaderFooter(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrlAppTemplate}/templates`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  public deleteDefaultEmailTemplate(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrlTemplate}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  public create(entity: IEmailTemplate): Promise<IEmailTemplate> {
    return new Promise<IEmailTemplate>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public createDefaultEmailTemplate(entity: IEmailTemplate): Promise<IEmailTemplate> {
    return new Promise<IEmailTemplate>((resolve, reject) => {
      axios
        .post(`${baseApiUrlAppTemplate}/templates`, { data: [entity] })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  public retrieveIdentifier(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrlTemplate + `/identifiers`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  public updateDefaultEmailTemplate(id: number, entity: IEmailTemplate): Promise<IEmailTemplate> {
    return new Promise<IEmailTemplate>((resolve, reject) => {
      axios
        .put(`${baseApiUrlTemplate}/${id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  public update(entity: IEmailTemplate): Promise<IEmailTemplate> {
    const { id, subject, header, body, footer, language } = entity;
    const payload = {
      id,
      subject,
      header,
      body,
      footer,
      language,
    };
    return new Promise<IEmailTemplate>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${id}`, payload)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
